function addZero(value) {
    if (value < 10) {
        return '0' + value
    } else {
        return value.toString()
    }
}

var date2string = function(dateTime){
    dateTime = new Date(dateTime)
    return `${dateTime.getFullYear().toString()}-${addZero(dateTime.getMonth() + 1)}-${addZero(dateTime.getDate())} ${dateTime.getHours()}:${addZero(dateTime.getMinutes())}:${addZero(dateTime.getSeconds())}`
}

var dateString = function(dateTime){
    return `${dateTime.getFullYear().toString()}-${addZero(dateTime.getMonth() + 1)}-${addZero(dateTime.getDate())}`
}
var weekDate = function(date){

    var now = new Date();
    if (date) {
        now = date
    }
    var nowTime = now.getTime()
    var day = now.getDay()|| 7
    var oneDayTime = 24*60*60*1000
    var MondayTime = nowTime - (day-1)*oneDayTime
    var SundayTime =  nowTime + (7-day)*oneDayTime
    var monday = dateString(new Date(MondayTime))
    var sunday = dateString(new Date(SundayTime))
    return `${monday} ~ ${sunday}`
}
var trim = function(str) {
	if(str == null){
		str = "";
	}
    return str.replace(/(^\s*)|(\s*$)/g, "");
};
export {
    date2string,
    weekDate,
    trim
}